export const GET_BILLINGPARTY_REQUEST = "GET_BILLINGPARTY_REQUEST";
export const GET_BILLINGPARTY_SUCCESS = "GET_BILLINGPARTY_SUCCESS";
export const GET_BILLINGPARTY_FAIL = "GET_BILLINGPARTY_FAIL";

export const CREATE_BILLINGPARTY_REQUEST = "CREATE_BILLINGPARTY_REQUEST";
export const CREATE_BILLINGPARTY_SUCCESS = "CREATE_BILLINGPARTY_SUCCESS";
export const CREATE_BILLINGPARTY_FAIL = "CREATE_BILLINGPARTY_FAIL";

export const UPDATE_BILLINGPARTY_REQUEST = "UPDATE_BILLINGPARTY_REQUEST";
export const UPDATE_BILLINGPARTY_SUCCESS = "UPDATE_BILLINGPARTY_SUCCESS";
export const UPDATE_BILLINGPARTY_FAIL = "UPDATE_BILLINGPARTY_FAIL";

export const DELETE_BILLINGPARTY_REQUEST = "DELETE_BILLINGPARTY_REQUEST";
export const DELETE_BILLINGPARTY_SUCCESS = "DELETE_BILLINGPARTY_SUCCESS";
export const DELETE_BILLINGPARTY_FAIL = "DELETE_BILLINGPARTY_FAIL";


//Billing Master Types
export const GET_BILLINGPARTYMASTER_REQUEST = "GET_BILLINGPARTYMASTER_REQUEST";
export const GET_BILLINGPARTYMASTER_SUCCESS = "GET_BILLINGPARTYMASTER_SUCCESS";
export const GET_BILLINGPARTYMASTER_FAIL = "GET_BILLINGPARTYMASTER_FAIL";